const baseConfig = {
  name: 'vshow-main',
  publicPath: '/vshow-main',
}

module.exports = baseConfig
